export { StudentPasswordPage } from "./StudentPasswordPage"
export type { PasswordChangeField, StudentPasswordPageProps, UIPasswordChange } from "./StudentPasswordPage"
